export const formatCurrency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format
export const formatDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format